import isNull from 'lodash-es/isNull'

import { EMPTY_LIST } from '../constants/common'

import { isApiSuccessStatus } from './api'

export function getMassActionsSuccessItemsLength(data) {
  if (data.success_ids) {
    return data.success_ids.length
  }

  return data.items?.filter(i => isApiSuccessStatus(i.status_code)).length
}

export function getMassActionsSuccessIds(data) {
  if (data?.success_ids) {
    return data.success_ids
  }

  return data?.items
    ?.filter(item => isApiSuccessStatus(item.status_code))
    .map(item => item.id)
}

export function parseActionsOnValidDivider(items) {
  if (items.length === 0) {
    return EMPTY_LIST
  }

  const firstItem = items[0]
  const lastItem = items[items.length - 1]

  if (
    isNull(firstItem) ||
    firstItem.Divider ||
    isNull(lastItem) ||
    lastItem.Divider
  ) {
    return items.filter(i => !isNull(i) && !i.Divider)
  }

  return items
}

export function filterPermittedActionsWithDividers(actions) {
  // Keep actions that are either:
  // - falsy (e.g., null) — used as dividers
  // - have a truthy `permission` property
  return actions.filter(
    action => !action || action.permission || action.Divider
  )
}
